import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { FaChartLine, FaSearch, FaBullhorn, FaEnvelope, FaUsers, FaCogs, FaChartPie, FaFacebook, FaGoogle, FaCodeBranch, FaMobile, FaEye, FaClipboardList, FaLinkedin } from "react-icons/fa";
import OurNumbers from "./OurNumbers";

const DigitalMarketing = () => {
  return (
    <Box sx={{ padding: "40px", maxWidth: "1200px", margin: "auto" }}>

      <Card
        sx={{
          background: "rgba(0, 0, 0, 0.9)",
          color: "white",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(15px)",
          textAlign: "center",
        }}
      >
        <CardContent>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Elevate Your Brand with Digital Marketing
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Unlock the power of data-driven marketing strategies to increase engagement, drive conversions, and scale your business online.
          </Typography>
        </CardContent>
      </Card>

      {/* Digital Marketing Services Section */}
      <Grid container spacing={3} sx={{ marginTop: "40px" }}>
        {marketingServices.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={glassyCardStyle}>
              <Box sx={logoBox}>{service.icon}</Box>
              <Typography variant="h6" fontWeight="bold">
                {service.title}
              </Typography>
              <Typography variant="body2" sx={{ marginTop: "10px", color: "#222" }}>
                {service.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Statistics Section - Animated UX Grid */}
      <OurNumbers />
    </Box>
  );
};

// Glassy Card Style
const glassyCardStyle = {
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backdropFilter: "blur(10px)",
  minHeight: "220px",
};

// Stylish Icon Box
const logoBox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "80px",
  height: "80px",
  borderRadius: "10px",
  backgroundColor: "rgba(211, 154, 158, 0.08)",
  marginBottom: "15px",
  boxShadow: "0 0 5px rgba(211, 154, 158, 0.5), 0 0 10px rgba(211, 154, 158, 0.5), 0 0 20px rgba(211, 154, 158, 0.5)",
  fontSize: "2rem",
};

// Digital Marketing Services List
const marketingServices = [
  {
    title: "SEO & Organic Growth",
    description: "Boost search rankings with advanced SEO techniques and keyword strategies.",
    icon: <FaSearch />,
  },
  {
    title: "PPC & Paid Advertising",
    description: "Maximize ROI with highly targeted pay-per-click advertising campaigns.",
    icon: <FaGoogle />,
  },
  {
    title: "Social Media Marketing",
    description: "Engage and grow your audience across platforms like Facebook, Instagram, and LinkedIn.",
    icon: <FaLinkedin />,
  },
  {
    title: "Content Marketing & Copywriting",
    description: "Create compelling content that drives traffic, builds trust, and converts leads.",
    icon: <FaClipboardList />,
  },
  {
    title: "Email Marketing & Automation",
    description: "Automate personalized email campaigns to nurture and convert leads effectively.",
    icon: <FaEnvelope />,
  },
  {
    title: "Growth Hacking & Conversion Optimization",
    description: "Use data-driven growth tactics to optimize conversion rates and accelerate business scaling.",
    icon: <FaChartLine />,
  },
  {
    title: "Influencer & Affiliate Marketing",
    description: "Leverage influencers and affiliates to expand your brand’s reach and credibility.",
    icon: <FaUsers />,
  },
  {
    title: "Data Analytics & Marketing Insights",
    description: "Track performance metrics and refine campaigns using advanced data analysis.",
    icon: <FaChartPie />,
  },
];

export default DigitalMarketing;
